import React, { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import { themeButtons } from "../../css/themeButtons";
import { Button } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, Form, Formik } from "formik";
import Modal from "../common/Modals/Modal";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import * as Yup from "yup";
import { FormControl, GreenCheckbox } from "../ObjectServices/styles";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import Box from "@material-ui/core/Box";
import { phoneRegExp } from "../../utils/phoneValidate";


const RenderAddPersone = ({ toggleShow, show, addPersone, messengers }) => {


  const contactSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, 'Слишком короткое имя')
      .max(50, 'Слишком длинное имя'),
    phone: Yup.string()
      .min(11, 'Введите корректный номер телефона (пример: +79999999999)')
      .max(19, 'Введите корректный номер телефона (пример: +79999999999)')
      .matches(phoneRegExp, 'Введите корректный номер телефона (пример: +79999999999)')
      .when('email', {
        is: (email) => !email || email.length === 0,
        then: Yup.string()
          .required('Обязательно для заполнения'),
        otherwise: Yup.string().nullable(),
      }),
    email: Yup.string()
      .email('Не корректный Email')
      .when('phone', {
        is: (phone) => !phone || phone.length === 0,
        then: Yup.string()
          .required('Обязательно для заполнения'),
        otherwise: Yup.string().nullable(),
      })
  }, [['email', 'phone']]);


  const onSubmit = (value) => {
    addPersone(value)
    toggleShow()
  }

  return (
    <Formik onSubmit={onSubmit}
            validationSchema={contactSchema}
            initialValues={{}}>
      {({ handleSubmit, errors, touched, values }) => (
        <Form>
          <Modal toggleShow={toggleShow} btnOkAction={handleSubmit} show={show}
                 title={"Добавление пользователя:"}
                 textBtnOk={"Добавить"}>
            <div className="row">
              <div className="com-md-6">
                <Field name="name">
                  {({ field }) => (
                    <TextField size="small"
                               {...field}
                               fullWidth
                               type="text" variant="outlined"
                               className="mb-3"
                               label="Имя*"
                               error={Boolean(errors.name && touched.name)}
                               helperText={
                                 errors.name &&
                                 touched.name &&
                                 String(errors.name)
                               }
                    />
                  )}
                </Field>
              </div>

              <div className="col-md-12 mb-3">
                <Field name="phone">
                  {({ field }) => (
                    <TextField size="small"
                               fullWidth
                               {...field}
                               type="text" variant="outlined"
                               label="Телефон"
                               error={Boolean(errors.phone && touched.phone)}
                               helperText={
                                 errors.phone &&
                                 touched.phone &&
                                 String(errors.phone)
                               }
                    />
                  )}
                </Field>

                {values.phone && !errors.phone && <div className="row">
                  {messengers && Object.keys(messengers).map(msg =>
                    <div key={msg} className="col-6">
                      <Field type="checkbox" name={msg}>
                        {({ field }) => (
                          <FormControl
                            label={messengers[msg]}
                            control={<GreenCheckbox {...field} />}
                          />
                        )}
                      </Field>
                    </div>
                  )}

                </div>}

              </div>


              <div className="col-md-12">
                <Field name="email">
                  {({ field }) => (
                    <TextField size="small"
                               fullWidth
                               {...field}
                               onBlur={field.onBlur}
                               type="text" variant="outlined"
                               className="mb-3"
                               label="Email"
                               error={Boolean(errors.email && touched.email)}
                               helperText={
                                 errors.email &&
                                 touched.email &&
                                 String(errors.email)
                               }
                    />
                  )}
                </Field>

              </div>

            </div>


            <Typography variant="body2" display="block" color="error">
              *Обязательно укажите номер телефона и/или email нового пользователя, чтобы мы могли
              отправить ему информацию для получения доступа в Личный кабинет
            </Typography>
          </Modal>
        </Form>
      )}
    </Formik>

  )
}

const RenderAccessItem = ({ id, phone, email, name, messenger, removePersone, accessType, messengers }) => {

  const messengerIcon = (messenger) => {
    if (messenger === 'WHATSAPP') {
      return 'whatsapp'
    }
    if (messenger === 'VIBER') {
      return 'viber'
    }
  }

  return (<div className="access-item">
      <div className="access-item__content">
        <div className="access-item__content__col">
          {name && <div className="name">{name}</div>}
          {phone && <div className="phone">{phone}</div>}
          {phone && messenger && messenger.length !== 0 &&
            <div className="messengers">
              {messenger.map(msg => <div key={msg}>
                <FontAwesomeIcon icon={["fab", messengerIcon(msg)]}/> {messengers && messengers[msg]}
              </div>)}
            </div>}

        </div>

        {email && <div className="access-item__content__col">
          <span className="mail">{email}</span>
        </div>}
      </div>
      <div className="access-item__action">
        <Button className="btn text-danger" onClick={() => removePersone(id, accessType)}>
          <FontAwesomeIcon icon={"trash"}
                           className="me-1"/> Удалить
        </Button>
      </div>

    </div>
  )
}


const RenderRemovePersonesConfirmation = ({ toggleShow, show, removedPersone, removePersoneConfirm }) => {

  const handleOk = () => {
    toggleShow()
    removePersoneConfirm()
  }

  return (
    <Modal toggleShow={toggleShow} btnOkAction={handleOk} show={show}
           title={"Удаление пользователя:"}
           textBtnOk={"Удалить"}>
      {removedPersone.name && <Box>
        <Typography variant="body1" component="span" className="me-2"><b>Имя:</b></Typography>
        <Typography component="span">{removedPersone.name}</Typography>
      </Box>}
      {removedPersone.phone && <Box>
        <Typography variant="body1" component="span" className="me-2"><b>Телефон:</b></Typography>
        <Typography component="span">{removedPersone.phone}</Typography>
      </Box>}
      {removedPersone.email && <Box>
        <Typography variant="body1" component="span" className="me-2"><b>Email:</b></Typography>
        <Typography component="span">{removedPersone.email}</Typography>
      </Box>}

    </Modal>
  )
}


const AccessRightDetail = (props) => {
  const { getMessengersList, messengers } = props

  const [access, setAccess] = useState({
    object: [
      {
        id: '33',
        phone: '+79000362151',
        email: "a.makarov@turizm24.info",
        name: 'Alexander',
        messenger: [
          'WHATSAPP',
          'VIBER'
        ]
      },
      {
        id: '37',
        phone: '+79000362151',
        email: "",
        name: 'Alexander',
        messenger: []
      },
      {
        id: '34',
        phone: '+7999999999',
        name: 'Alexander',
        messenger: [
          'WHATSAPP',
        ]
      },
      {
        id: '35',
        name: 'Alexander',
        email: "a.makarov@turizm24.info",
        messenger: [
          'VIBER'
        ]
      },
      {
        id: '36',
        name: 'Alexander',
        email: "a.makarov@turizm24.info",
        messenger: []
      }],
    invoices: [
      {
        id: '33',
        phone: '+79000362151',
        email: "a.makarov@turizm24.info",
        name: 'Alexander',
        messenger: [
          'WHATSAPP',
          'VIBER'
        ]
      },
      {
        id: '37',
        phone: '+79000362151',
        email: "",
        name: 'Alexander',
        messenger: []
      },
      {
        id: '34',
        phone: '+7999999999',
        name: 'Alexander',
        messenger: [
          'WHATSAPP',
        ]
      },
      {
        id: '35',
        name: 'Alexander',
        email: "a.makarov@turizm24.info",
        messenger: [
          'VIBER'
        ]
      },
      {
        id: '36',
        name: 'Alexander',
        email: "a.makarov@turizm24.info",
        messenger: []
      }],
  })


  const [unsavedPage, toggleUnsavedPage] = useState(false)
  const [whereAppendPersones, setWhereAppendPerosones] = useState()
  const [removedPersone, setRemovedPersone] = useState()
  const [removedAccessType, setRemovedAccessType] = useState()

  useEffect(() => {
    getMessengersList()
  }, [])


  let [showAddPersone, toggleModalShowAddPersone] = useState(false);
  const toggleShowAddPersone = (accessType) => {
    if (!showAddPersone) {
      setWhereAppendPerosones(accessType)
    }
    toggleModalShowAddPersone(!showAddPersone)
  };

  let [showRemoveConfirmation, toogleShowRemove] = useState(false);
  const toggleShowRemoveConfirmation = (removePersone, accessType) => {
    if (!showRemoveConfirmation) {
      setRemovedPersone(() => {
        return access[accessType].filter(item => item.id === removePersone)[0]
      })
      setRemovedAccessType(accessType)
    }
    toogleShowRemove(!showRemoveConfirmation)
  };

  const savePageHandler = () => {
    // console.log("savePage", access)
    toggleUnsavedPage(false)
  }

  const addPersone = (persone) => {
    let finalPersone = {
      name: persone.name,
      phone: persone.phone,
      email: persone.email,
      messenger: [persone.WHATSAPP && 'WHATSAPP', persone.VIBER && 'VIBER']
    }

    setAccess(prev => {
      return { ...prev, [whereAppendPersones]: [...prev[whereAppendPersones], finalPersone] }
    })
    toggleUnsavedPage(true)

  }


  const removePersonesWithConfirm = () => {
    toggleUnsavedPage(true)
    setAccess(prev => {
      return { ...prev, [removedAccessType]: prev[removedAccessType].filter(item => item.id !== removedPersone.id) }
    })
  }

  const buttons = themeButtons()
  return (
    <div className="main">
      <div className="container-fluid">
        <h4>Отель Сириус</h4>

        <div className="row">
          <div className="col-md-6">
            <Card className="card access-list">
              <CardContent className="card-header">
                <h5 className="access-list-title mb-0">Доступ к объекту:</h5>
              </CardContent>
              <Divider style={{ flexShrink: 1 }}/>
              <CardContent className="card-body access-list__alert-wrp">
                <div className="alert alert-warning">
                  В этом блоке вы можете добавить людей которые будут и иметь доступ к
                  редактированию
                  выбранного объекта (например администраторы или управляющие)
                </div>
              </CardContent>
              <CardContent className="card-body">

                {access && access.object && access.object.map(item => <RenderAccessItem
                  key={item.id} {...item} messengers={messengers}
                  removePersone={toggleShowRemoveConfirmation}
                  accessType={"object"}/>)}


              </CardContent>
              <Divider className="mt-auto"/>
              <CardContent className="card-footer">

                <div className="access-item__add">
                  <Button onClick={() => toggleShowAddPersone("object")} variant="outlined"
                          className={`btn ${buttons.btnGreenOutline}`}>
                    <FontAwesomeIcon icon={"plus"} className="me-1"/> Добавить
                  </Button>
                </div>

              </CardContent>
            </Card>
          </div>

          <div className="col-md-6">
            <Card className="card access-list">
              <CardContent className="card-header">
                <h5 className="access-list-title mb-0">Доступ к счетам:</h5>
              </CardContent>
              <Divider/>
              <CardContent className="card-body access-list__alert-wrp">
                <div className="alert alert-warning">
                  В этом блоке вы можете добавить людей которые будут и иметь доступ к
                  счетам и информации о бронированиях
                  выбранного объекта (например бухгалтеры)
                </div>
              </CardContent>
              <CardContent className="card-body">
                {access && access.invoices && access.invoices.map(item => <RenderAccessItem
                  key={item.id} {...item} messengers={messengers}
                  removePersone={toggleShowRemoveConfirmation}
                  accessType={"invoices"}/>)}

              </CardContent>
              <Divider className="mt-auto"/>
              <CardContent className="card-footer">

                <div className="access-item__add">
                  <Button variant="outlined" onClick={() => toggleShowAddPersone("invoices")}
                          className={`btn ${buttons.btnGreenOutline}`}>
                    <FontAwesomeIcon icon={"plus"} className="me-1"/> Добавить
                  </Button>
                </div>

              </CardContent>
            </Card>
          </div>
        </div>
      </div>


      {unsavedPage && <StickyBottomButton action={savePageHandler}/>}

      <RenderAddPersone toggleShow={toggleShowAddPersone} show={showAddPersone} addPersone={addPersone}
                        messengers={messengers}/>

      {removedPersone &&
        <RenderRemovePersonesConfirmation toggleShow={toggleShowRemoveConfirmation}
                                          show={showRemoveConfirmation}
                                          removedPersone={removedPersone}
                                          removePersoneConfirm={removePersonesWithConfirm}/>}
    </div>
  );
};

export default AccessRightDetail
